import script from "./WithdrawalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalView.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalView.vue?vue&type=style&index=0&id=0f80b470&lang=scss"

const __exports__ = script;

export default __exports__